import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
// import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable({providedIn:'root'})
export class MenubarService {
    displayFlag:boolean=false;
  private dataSource = new BehaviorSubject<boolean>(false);
  data = this.dataSource.asObservable();

  private Menudatalist = new BehaviorSubject<any[]>([]);
  datalist = this.Menudatalist.asObservable();


  constructor(private http: HttpClient) { }

  updatedDataSelection(data: any){
      
    this.dataSource.next(data);
  }
//   setData(data: any){
//     this.dataSource. (data);
//   }

tempholdMenuData(Details: any) {
  this.Menudatalist.next(Details);
}

  
}